import { render } from "./ModalProceed.vue?vue&type=template&id=74edd136&scoped=true"
import script from "./ModalProceed.vue?vue&type=script&lang=js"
export * from "./ModalProceed.vue?vue&type=script&lang=js"

import "./ModalProceed.vue?vue&type=style&index=0&id=74edd136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74edd136"]])

export default __exports__